/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { AWSRegionsEnum } from './aWSRegionsEnum';


export interface LambdaBucketAccessModifySpec { 
    /**
     * Accounts to add to the bucket\'s accesslist
     */
    add_accounts?: Array<string>;
    /**
     * Bucket Name
     */
    bucket_name: string;
    region_id: AWSRegionsEnum;
    /**
     * Accounts to remove to the bucket\'s accesslist
     */
    remove_accounts?: Array<string>;
    service_type: ServiceTypeEnum;
}
export namespace LambdaBucketAccessModifySpec {
}


